export const SET_PROD_SERV_GROUPS = "SET_PROD_SERV_GROUPS";
export const APPEND_PROD_SERV_GROUP = "APPEND_PROD_SERV_GROUP";
export const SET_CHANGE_CATEGORY_DATA = "SET_CHANGE_CATEGORY_DATA";

